import {
  MonitorOutlined,
  MinusCircleOutlined,
  SearchOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { App, Button, Col, Descriptions, Row, Skeleton, Space } from "antd";
import React, { useState, useRef } from "react";
import { useQuery, useMutation } from "react-query";
import { useParams } from "react-router-dom";
import ECard from "components/ECard";
import EDescription from "components/EDescription";
import ETable from "components/ETable";
import ETag from "components/ETag";
import InlineCopyable from "components/InlineCopyable";
import { ColoredStatistic, Curl, ISO8601 } from "components/Jarvis";
import { RefundModal } from "components/RefundModalForm";

import PaymentReceipt from "components/PaymentReceipt";
import axios from "axios";

export default function PaymentPage({ pID }) {
  let { paymentID } = useParams();
  if (pID) {
    paymentID = pID;
  }

  const { modal, message } = App.useApp();
  const [queryLoading, setQueryLoading] = useState(false);
  const [open, setOpen] = useState();
  const refPaymentReceipt = useRef();

  const { isFetching, data: paymentData } = useQuery(
    ["payments", paymentID],
    () => {
      return Curl.get(`/payplus/gateway/resources/payments/${paymentID}`).then(
        (res) => res.payload
      );
    }
  );

  if (isFetching || !paymentData) {
    return <Skeleton active />;
  }
  const receiptOnClick = () => {
    refPaymentReceipt.current.show(paymentID);
  };

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ECard
          title={`Payment#${paymentID}`}
          extra={
            <Space>
              <Button
                loading={queryLoading}
                onClick={() => {
                  setQueryLoading(true);
                  Curl.get(
                    `/payplus/gateway/resources/payments/${paymentID}/query`
                  )
                    .then((res) => {
                      setQueryLoading(false);
                      if ("msg" in res.payload) {
                        return message.success("Payment Status updated.");
                      }
                      return message.info("Status already in sync.");
                    })
                    .catch((err) => {
                      setQueryLoading(false);
                      message.success("Somethings wrong.");
                    });
                }}
                icon={<MonitorOutlined />}
                type="primary"
              >
                Query
              </Button>
              {paymentData.status == "Completed" && (
                <Button
                  onClick={receiptOnClick}
                  icon={<FileTextOutlined />}
                  type="primary"
                >
                  Receipt
                </Button>
              )}
              {paymentData.available_refund_amount > 0 && (
                <Button
                  onClick={() => setOpen(true)}
                  icon={<MinusCircleOutlined />}
                  type="primary"
                >
                  Refund
                </Button>
              )}
              <RefundModal
                open={open}
                payment={paymentData}
                reference={paymentID}
                onCancel={() => setOpen(false)}
              />
            </Space>
          }
        >
          <PaymentReceipt
            ref={refPaymentReceipt}
            paymentID={paymentData.uuid}
          />
          <EDescription column={3}>
            <Descriptions.Item label="UUID">
              <InlineCopyable>{paymentData.uuid}</InlineCopyable>
            </Descriptions.Item>
            <Descriptions.Item label="Reference">
              <InlineCopyable>{paymentData.order_reference}</InlineCopyable>
            </Descriptions.Item>
            <Descriptions.Item label="Order">
              <ColoredStatistic
                prefix={paymentData.order_currency}
                value={paymentData.order_amount}
              />
            </Descriptions.Item>
            <Descriptions.Item label="Surcharge">
              <ColoredStatistic
                prefix={paymentData.order_currency}
                value={paymentData.order_surcharge_amount}
              />
            </Descriptions.Item>
            <Descriptions.Item label="Status">
              <ETag>{paymentData.status}</ETag>
            </Descriptions.Item>
            <Descriptions.Item label="Created">
              {ISO8601(paymentData.created_at)}
            </Descriptions.Item>
            <Descriptions.Item label="Updated">
              {ISO8601(paymentData.updated_at)}
            </Descriptions.Item>
            <Descriptions.Item label="Expiry">
              {ISO8601(paymentData.expired_at)}
            </Descriptions.Item>
            <Descriptions.Item label="Hosted Payment Page">
              <InlineCopyable>{paymentData.page_url}</InlineCopyable>
            </Descriptions.Item>
            {paymentData.status == "Completed" && (
              <Descriptions.Item label="Payment Receipt">
                <InlineCopyable>{`${axios.defaults.baseURL}/payments/${paymentData.uuid}/receipt?print=true`}</InlineCopyable>
              </Descriptions.Item>
            )}
          </EDescription>
        </ECard>
      </Col>
      <Col span={24}>
        <ECard title={`Transactions`}>
          <ETable
            name={["payments", paymentID, "transactions"]}
            uri={`/payplus/gateway/resources/payments/${paymentID}/transactions`}
            columns={[
              {
                title: "UUID",
                render: (item) => {
                  return <InlineCopyable>{item.uuid}</InlineCopyable>;
                },
              },
              {
                title: "Type",
                align: "center",
                render: (item) => {
                  return item.type;
                },
              },
              {
                title: "Status",
                align: "center",
                render: (item) => {
                  return <ETag>{item.status}</ETag>;
                },
              },
              {
                title: "Fee",
                align: "right",
                render: (item) => {
                  return (
                    <ColoredStatistic
                      prefix={item.fee_currency}
                      value={item.fee_amount}
                    />
                  );
                },
              },
              {
                title: "Order",
                align: "right",
                render: (item) => {
                  return (
                    <ColoredStatistic
                      prefix={item.order_currency}
                      value={item.order_amount}
                    />
                  );
                },
              },
              {
                title: "Created at",
                align: "center",
                render: (item) => {
                  return ISO8601(item.created_at);
                },
              },
              // {
              //   render: (item) => {
              //     return (
              //       <>
              //         <Space>
              //           <Button
              //             icon={<SearchOutlined />}
              //             size="small"
              //             onClick={() =>
              //               showTransactionsDetailDrawer(
              //                 paymentData.uuid,
              //                 item.uuid
              //               )
              //             }
              //           >
              //             View
              //           </Button>
              //         </Space>
              //       </>
              //     );
              //   },
              // },
            ]}
          />
          {/* <AlipayView ref={alipayViewRef} /> */}
        </ECard>
      </Col>
      <Col span={12}>
        <ECard title="Notifications">
          <ETable
            name={["payments", paymentID, "notifications"]}
            uri={`/payplus/gateway/resources/payments/${paymentID}/notifications`}
            columns={[
              {
                title: "Time",
                align: "center",
                render: (item) => {
                  return ISO8601(item.updated_at);
                },
              },
              {
                title: "URL",
                render: (item) => {
                  return <InlineCopyable>{item.notify_url}</InlineCopyable>;
                },
              },
              {
                title: "Method",
                align: "center",
                render: (item) => {
                  return item.method;
                },
              },
              {
                title: "HTTP Code",
                align: "center",
                render: (item) => {
                  return item.http_code;
                },
              },
            ]}
          />
        </ECard>
      </Col>
    </Row>
  );
}
